import { usePunditUserContext } from "@circle-react/contexts";

export const useIsEventOwner = (event: any) => {
  const { currentCommunityMember } = usePunditUserContext();
  if (!event || !currentCommunityMember) return false;
  return event?.community_member_id === currentCommunityMember?.id;
};
